import objstorage from "@/common/localstorage/storage.js";

function buttonSet() {
  try {
    const info = objstorage.get("userinfo") || {};
    return info.buttonSet || [];
  } catch (e) {
    return [];
  }
}

/** @param {string} menuItem @param {'CHECK'|'ADD'|'EDIT'|'DELETE'} type */
export function hasBtn(menuItem, type) {
  return buttonSet().some(
    (b) =>
      b &&
      b.menuItem === menuItem &&
      b.buttonType &&
      b.buttonType.name === type
  );
}

export function hasWms() {
  return buttonSet().some(
    (b) => b && (b.typeDesc === "WMS" || (b.type && b.type.name === "WMS"))
  );
}

export default { hasBtn, hasWms };



// WEBPACK FOOTER //
// ./src/common/utils/permission.js